import { TYPE_COLLECTION } from './input-types';
import { ASSIGNED_TO } from '../constants';

export const id = ASSIGNED_TO;
export const apiKey = 'AssignedTo';
export const type = TYPE_COLLECTION;

export const assignedTo = {
  id,
  apiKey,
  type,
};
